import { Checkbox, Table } from "flowbite-react";
import React, { useState, useEffect, useRef } from "react";
import { CgScrollV } from "react-icons/cg";
import { TbArrowsSort } from "react-icons/tb";
import { apiBaseurl } from "../utils/ApiBaseurl";
import { HashLoader } from "react-spinners";

const CheckboxTable = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortOrder, setSortOrder] = useState("asc");
  const tableRef = useRef(null);

  useEffect(() => {
    if (tableRef.current) {
      const viewportHeight = window.innerHeight;
      tableRef.current.style.height = `${viewportHeight}px`;
    }
  }, []);

  const scrollContainerRef = useRef(null);
  const [scrollDirection, setScrollDirection] = useState("down");
  const handleToggleScroll = () => {
    if (scrollContainerRef.current) {
      if (scrollDirection === "down") {
        const scrollableHeight =
          scrollContainerRef.current.scrollHeight -
          scrollContainerRef.current.clientHeight;
        scrollContainerRef.current.scrollTop = scrollableHeight;
        setScrollDirection("up");
      } else {
        scrollContainerRef.current.scrollTop = 0;
        setScrollDirection("down");
      }
    }
  };

  const PHASE_COLOR_MAP = {
    "On Boarding": "bg-[#E5EAEF]",
    "Plan Preparation": "bg-[#FFC8B0]",
    "Plan Design": "bg-[#FEF0CF]",
    "Plan Implementation": "bg-[#D4FAF2]",
    "Plan Maintenence": "bg-[#FAAFE8]",
  };

  const PHASE_COLOR_HOVER_MAP = {
    "On Boarding": "hover:bg-[#F2F4F5]",
    "Plan Preparation": "hover:bg-[#FFF3ED]",
    "Plan Design": "hover:bg-[#FCF4E1]",
    "Plan Implementation": "hover:bg-[#E8FAF6]",
    "Plan Maintenence": "hover:bg-[#FAC3ED]",
  };

  useEffect(() => {
    fetch(`${apiBaseurl}backend/api/user-tasks`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${
          JSON.parse(localStorage.getItem("authTokens")).access
        }`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        sortTasksByDate(data);
        setLoading(false);
      });
  }, []);

  const sortTasksByDate = (tasks) => {
    const sortedTasks = [...tasks].sort((a, b) => {
      const dateA = new Date(a.due_date);
      const dateB = new Date(b.due_date);

      if (sortOrder === "asc") {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    setTasks(sortedTasks);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  return (
    <>
      {tasks.length > 0 ? (
        <>
          <section
            className="dark:bg-gray-900 flex flex-col h-screen"
            ref={tableRef}
          >
            <div className="overflow-hidden bg-white shadow-md dark:bg-gray-800 sm:rounded-md flex-grow">
              <div
                className="overflow-x-auto overflow-y-auto h-full"
                ref={scrollContainerRef}
              >
                <Table hoverable>
                  <Table.Head>
                    <Table.HeadCell></Table.HeadCell>
                    <Table.HeadCell>Phase</Table.HeadCell>
                    <Table.HeadCell>Task Name</Table.HeadCell>
                    <Table.HeadCell
                      onClick={() => {
                        sortTasksByDate(tasks)
                      }}
                      className="cursor-pointer"
                    >
                      <div className="flex justify-start items-center">
                        <div className="pr-2">Due Date</div>
                        <TbArrowsSort />
                      </div>
                    </Table.HeadCell>
                    <Table.HeadCell className="whitespace-nowrap">
                      Submission Date
                    </Table.HeadCell>
                  </Table.Head>
                  <Table.Body className="divide-y">
                    {tasks.map((task) => {
                      return (
                        <Table.Row
                          className={`dark:border-gray-700 dark:bg-gray-800 ${
                            PHASE_COLOR_MAP[task.phase]
                          } ${PHASE_COLOR_HOVER_MAP[task.phase]}`}
                          key={task.id}
                        >
                          <Table.Cell>
                            <Checkbox checked={task.is_checked} disabled />
                          </Table.Cell>
                          <Table.Cell className="font-medium text-[#0E0D0D] dark:text-white tracking-tight">
                            {task.phase}
                          </Table.Cell>
                          <Table.Cell className="font-bold text-[#0E0D0D] dark:text-white tracking-tight">
                            {task.task_name}
                          </Table.Cell>
                          <Table.Cell className="whitespace-nowrap text-[#0E0D0D] tracking-tight w-60">
                            {task.due_date}
                          </Table.Cell>
                          <Table.Cell className="whitespace-nowrap text-[#0E0D0D] tracking-tight">
                            {task.submission_date}
                          </Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
              </div>
            </div>
            <div className="relative w-full flex items-center justify-center hidden md:block mb-4">
              <button className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <CgScrollV
                  size={30}
                  className="text-gray-500 mb-16"
                  onClick={() => {
                    handleToggleScroll();
                  }}
                />
              </button>
            </div>
          </section>
        </>
      ) : (
        <div className="flex flex-col md:flex-row items-center justify-center h-screen">
          <HashLoader
            size={"128px"}
            color="#20396F"
            loading={loading}
            speedMultiplier={2}
          />
        </div>
      )}
    </>
  );
};

export default CheckboxTable;
